import React from 'react';
import 'antd/dist/antd.css';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import {Popover, Button, Row, Col } from 'antd';
import ReportIcon from "../../../../assets/report.png";
import ArrowDownIcon from "../../../../assets/down-arrow.png";
import InfoIcon from "../../../../assets/info.png";
import "./customStyle.css";

class CustomHeaderWithTooltip extends React.Component {
    state = {
        visible: false,
    };

    hide = () => {
        this.setState({
            visible: false,
        },()=>{this.props.onHide(false)});                                                                                                                                                                                                                                                                              
    };

    handleVisibleChange = visible => {
        this.setState({ visible },()=>{this.props.onHide(false)});
    };


    render() {
    const content = (
        <div className="tooltipContainer">
            {/* <a className="popupClose" onClick={this.hide}><CloseOutlined /></a> */}
            <div className="topLine">
                <span>view Reports in myDocs</span>
                <img src={ArrowDownIcon} />
            </div>
            <div className="bar">
                
                <div className="buttonSection">
                    <img src={ReportIcon} className="reportIcon"/>
                    <span>{this.props.title == 'Report Status' ? "" : "0/3"}</span>
                    <Button type="primary">{this.props.title == "Report Status" ? "Upload" : "Sign"}</Button>
                    <span>{this.props.title == 'Report Status' ? "1/5" : "5/5"}</span>
                </div>
            </div>
            <div className="buttomLine">
                <div className="leftSide">
                    {this.props.title == "Signature Status" ? (
                    <>
                        <img src={ArrowDownIcon} />
                        <span>signed / total signers</span>
                    </>
                    ) : ("") }
                </div>
                <div className="rightSide">
                    <img src={ArrowDownIcon} />
                    <span>received / required</span>
                </div>
                    
            </div>
        </div>
    );
    return (
        <Popover 
            content={
                <div>
                {content}
                {/* <a onClick={this.hide}>Close</a> */}
                </div>
            }
            
            visible={this.state.visible}
            onVisibleChange={this.handleVisibleChange}
            placement="top" 
            trigger="click" arrowPointAtCenter>
            <a className="infoBtn">
                 {this.props.title}
                <img src={InfoIcon} />
            </a>
        </Popover>
    );
    }
}

export default CustomHeaderWithTooltip;